module.exports = __webpack_public_path__ + "static/media/watts.edd5b2aa.jpg";